import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Divider from "antd/es/divider";
import Row from "antd/es/row";
import DetailsColumn from "./DetailsColumn";

const RoomDetails = ({
  room,
  transactionRecord,
  symbol,
  getFixedTwoDecimalValue,
}) => (
  <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
    <Row type="flex" justify="space-between">
      <Col style={{ paddingTop: "5px" }}>
        <Badge
          overflowCount={9999999}
          count={`Room ${room.roomNumber}`}
          className="details-badge"
        />
      </Col>
    </Row>
    <div className="left-margin">
      <Row>
        <DetailsColumn
          label={"Type"}
          value={
            transactionRecord.cashPageDetails[0].order_status === "2" ? "Refund" : "Collect Cash"
          }
        />

        <DetailsColumn
          label={"PMS Confirmation Number"}
          value={room.pmsConfirmationNumber || "-"}
        />

        <DetailsColumn
          label={"Category"}
          value={room.category ? room.category : "-"}
        />
      </Row>
    </div>

    <Divider />

    <div className="left-margin">
      <Row>
        <DetailsColumn
          label={
            transactionRecord.cashPageDetails[0].order_status === "2"
              ? "Room Refund"
              : "Room Amount"
          }
          value={room.roomAmount ? `${symbol}${getFixedTwoDecimalValue(room.roomAmount)}` : "-"}
        />

        <DetailsColumn
          label={
            transactionRecord.cashPageDetails[0].order_status === "2"
              ? "Deposit Refund"
              : "Room Deposit"
          }
          value={room.roomDeposit ? `${symbol}${getFixedTwoDecimalValue(room.roomDeposit)}` : "-"}
        />

        <DetailsColumn
          label={
            transactionRecord.cashPageDetails[0].order_status === "2"
              ? "Misc. Refund"
              : "Misc. Amount"
          }
          value={room.miscAmount ? `${symbol}${getFixedTwoDecimalValue(room.miscAmount)}` : "-"}
        />
      </Row>
    </div>

    <Divider />

    <div className="left-margin">
      <Row>
        <DetailsColumn
          label={
            transactionRecord.cashPageDetails[0].order_status === "2"
              ? "Parking Refund"
              : "Parking Amount"
          }
          value={
            room.total_parking_amount
              ? `${symbol}${getFixedTwoDecimalValue(room.total_parking_amount)}`
              : "-"
          }
        />
        <DetailsColumn
          label={
            transactionRecord.cashPageDetails[0].order_status === "2"
              ? "Total Refund"
              : "Sub Total"
          }
          value={room.subTotal ? `${symbol}${getFixedTwoDecimalValue(room.subTotal)}` : "-"}
        />
      </Row>
    </div>
    <Divider />
  </Card>
);

RoomDetails.propTypes = {
  transactionRecord: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  symbol: PropTypes.string.isRequired,
};

export default RoomDetails;
